var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 38.25H15.75V22.5H20.25V38.25ZM29.25 38.25H24.75V15.75H29.25V38.25ZM38.25 38.25H33.75V29.25H38.25V38.25ZM42.75 42.75H11.25V11.25H42.75V42.975M42.75 6.75H11.25C8.775 6.75 6.75 8.775 6.75 11.25V42.75C6.75 45.225 8.775 47.25 11.25 47.25H42.75C45.225 47.25 47.25 45.225 47.25 42.75V11.25C47.25 8.775 45.225 6.75 42.75 6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportg1);
export default __webpack_public_path__ + "static/media/reportg1.f20b499aee246c05c7528ecf5ba45507.svg";
export { ForwardRef as ReactComponent };